import { combineReducers } from 'redux';
import itemListingReports from '../itemlistingreport/state/reducer';
import WarehouseReports from './../warehousereport/state/reducers';
import onHandReports from './../onhandreport/state/reducer';
import transactionHistoryReports from './../transactionhistoryreport/state/reducer';
import reportsCommonReducer from './../commonState/reducer';
import warehousePickListReport from './../warehousepicklist/state/reducers';

export default combineReducers({
  itemListingReports,
  WarehouseReports,
  onHandReports,
  transactionHistoryReports,
  reportsCommonReducer,
  warehousePickListReport,
});



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/state/reducers.js